<app-form-header class="backoffice-page-header"></app-form-header>
<mat-card>
<div class="form-box">
  <form [formGroup]="formularioAbs">

    <div class="container"
         fxLayout
         fxLayout.xs="column"
         fxLayoutAlign="center"
         fxLayoutGap="10px"
         fxLayoutGap.xs="0">

      <mat-form-field appearance="outline">
        <mat-label>Version</mat-label>
        <input matInput formControlName="version" type="text" placeholder="Ingrese la version de la aplicacion" [errorStateMatcher]="macherError">
        <mat-error *ngIf="f.version.hasError('required')">{{getErrorMessage('version')}}</mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline">
        <mat-label>Descripcion</mat-label>
        <input matInput formControlName="descripcion" type="text" placeholder="Ingrese la descripcion de la App">
        <mat-error *ngIf="f.descripcion.hasError('required')">{{getErrorMessage('descripcion')}}</mat-error>
      </mat-form-field>

      <app-my-slide-togle [dis]="dis" txtTitulo="Activo" txtTrue="Activo" txtFalse="Inactivo"
                          [inputBoolean]="f.activo.value"
                          (outputBolean)="f.activo.setValue($event)"></app-my-slide-togle>

       <app-finder-autocomplete [dis]="dis" [columna]="['nombre']" [item]="f.aplicacion.value"
                               [service]="aplicacionService"
                               placeHolder="Aplicacion"
                               (output)="f.aplicacion.setValue($event);"></app-finder-autocomplete>

    </div>

    <div class="container"
         fxLayout
         fxLayout.xs="column"
         fxLayoutAlign="center"
         fxLayoutGap="10px"
         fxLayoutGap.xs="0">
    </div>
    <div class="container"
         fxLayout
         fxLayout.xs="column"
         fxLayoutAlign="center"
         fxLayoutGap="10px"
         fxLayoutGap.xs="0">

    </div>
    <div class="button-box" *ngIf="abm">
      <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()"
                        (warnEmiter)="eliminar(formularioAbs.value)"
                        [hideBtnWarn]="!editar" [submitted]="submitted"></app-form-actions>
    </div>
  </form>


</div>
</mat-card>
